var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-container",attrs:{"id":"chat-container"}},[_c('div',{staticClass:"chat-list-container",attrs:{"id":"chat-list-container"}},[_c('ChatList')],1),_c('div',{staticClass:"chat-input-container"},[_c('ChatInput')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }